// Hero Learn Norwegian - Custom JavaScript
// Handles dynamic interactions and animations

document.addEventListener('DOMContentLoaded', function() {
  initHeroAnimations();
});

/**
 * Initialize entrance animations for hero elements
 */
function initHeroAnimations() {
  const heroSection = document.querySelector('.hero-learn-norwegian');
  if (!heroSection) return;

  const title = heroSection.querySelector('.hero-learn-norwegian__title');
  const description = heroSection.querySelector('.hero-learn-norwegian__description');
  const buttons = heroSection.querySelector('.hero-learn-norwegian__buttons');
  const cards = heroSection.querySelectorAll('.hero-learn-norwegian__card');

  // Add entrance animations with stagger
  if (title) {
    setTimeout(() => {
      title.style.opacity = '0';
      title.style.transform = 'translateY(20px)';
      title.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      
      requestAnimationFrame(() => {
        title.style.opacity = '1';
        title.style.transform = 'translateY(0)';
      });
    }, 100);
  }

  if (description) {
    setTimeout(() => {
      description.style.opacity = '0';
      description.style.transform = 'translateY(20px)';
      description.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      
      requestAnimationFrame(() => {
        description.style.opacity = '1';
        description.style.transform = 'translateY(0)';
      });
    }, 200);
  }

  if (buttons) {
    setTimeout(() => {
      buttons.style.opacity = '0';
      buttons.style.transform = 'translateY(20px)';
      buttons.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      
      requestAnimationFrame(() => {
        buttons.style.opacity = '1';
        buttons.style.transform = 'translateY(0)';
      });
    }, 300);
  }

  // Animate cards with stagger
  cards.forEach((card, index) => {
    setTimeout(() => {
      card.style.opacity = '0';
      card.style.transform = card.classList.contains('hero-learn-norwegian__card--middle') 
        ? 'translate(-50%, -50%) scale(0.8)' 
        : 'scale(0.8)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      
      requestAnimationFrame(() => {
        card.style.opacity = '1';
        card.style.transform = card.classList.contains('hero-learn-norwegian__card--middle')
          ? 'translate(-50%, -50%) scale(1)'
          : 'scale(1)';
      });
    }, 400 + (index * 100));
  });
}

/**
 * Handle card hover effects with enhanced interaction
 */
document.addEventListener('DOMContentLoaded', function() {
  const cards = document.querySelectorAll('.hero-learn-norwegian__card');
  
  cards.forEach(card => {
    card.addEventListener('mouseenter', function() {
      // Slightly scale down other cards when one is hovered
      cards.forEach(otherCard => {
        if (otherCard !== card) {
          otherCard.style.transform = otherCard.classList.contains('hero-learn-norwegian__card--middle')
            ? 'translate(-50%, -50%) scale(0.95)'
            : 'scale(0.95)';
          otherCard.style.opacity = '0.7';
        }
      });
    });

    card.addEventListener('mouseleave', function() {
      // Reset all cards
      cards.forEach(otherCard => {
        otherCard.style.transform = otherCard.classList.contains('hero-learn-norwegian__card--middle')
          ? 'translate(-50%, -50%) scale(1)'
          : 'scale(1)';
        otherCard.style.opacity = '1';
      });
    });
  });
});
